module.exports = {
      id: "usp-3-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.e66ad95c.svg#usp-3-usage",
      toString: function () {
        return this.url;
      }
    }